import { type FC, type ReactNode, useEffect } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import { useServices } from "appServices";
import { useMount } from "helpers/hooks/useMount";
import { matchFirstPathPart } from "helpers/url";
import { Page } from "pages";
import { FlowType } from "services/user/userTypes";

interface UserFlowGuardProps {
  children: ReactNode;
}

export const UserFlowGuard: FC<UserFlowGuardProps> = ({ children }) => {
  const {
    userStore: { flowType, status },
    analyticsManager,
    config,
  } = useServices();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useMount(() => {
    analyticsManager.event("user-state", {
      canProceed: status.canProceed,
      companies: status.companies.join(),
      blockedByOnboarding: status.blockedByOnboarding,
    });

    if (!status.canProceed) {
      navigate(Page.ExistedCustomer);
    }
  });

  useEffect(() => {
    if (config.isAU) {
      const isOnAbnPath = matchFirstPathPart(pathname, Page.Abn);
      const isOnSoleTraderPath = matchFirstPathPart(pathname, Page.SoleTrader);

      switch (flowType) {
        case FlowType.AcnAbn:
          if (isOnAbnPath || isOnSoleTraderPath) {
            navigate(Page.Main);
          }
          break;
        case FlowType.Abn:
          if (isOnSoleTraderPath || !isOnAbnPath) {
            navigate(Page.Abn);
          }
          break;
        case FlowType.SoleTraderAbn:
          if (isOnAbnPath || !isOnSoleTraderPath) {
            navigate(Page.SoleTrader);
          }
          break;
      }
    }
  }, [flowType]);

  return <>{children}</>;
};
